(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyersSelectImageDetail', FiltersFlyersController);

    /** @ngInject */
    function FiltersFlyersController($uibModalInstance, isImmoContext, allFlyerImages, detailFlyerImages, identifier, $translate) {
        var vm = this;

        vm.$onInit = init;
        vm.sortDetailFlyerImagesComparator = sortDetailFlyerImagesComparator;
        vm.updateFlyerImagesDetailOrder = updateFlyerImagesDetailOrder;
        vm.toggleDetailFlyerImage = toggleDetailFlyerImage;
        vm.update = update;
        vm.close = close;

        vm.isImmoContext = isImmoContext;
        vm.allFlyerImages = allFlyerImages ? allFlyerImages : [];
        vm.detailFlyerImages = detailFlyerImages ? detailFlyerImages : [];
        vm.sortableOptionsDetail = {
            disabled: true
        };
        var THRESHOLD_VALUE = 70;

        function init() {
            if (vm.isImmoContext) {
                vm.unit = identifier;
            } else {
                vm.size = identifier;
            }

            vm.modalTitle = truncateText(getTitle(), THRESHOLD_VALUE);

            vm.updateFlyerImagesDetailOrder();
        }

        function getTitle() {
            return $translate.instant(
                getContextTranslateKey('flyers.detail.select-image.title'),
                {
                    identifier: identifier
                }
            );
        }

        function sortDetailFlyerImagesComparator(v1, v2) {
            var before = -1;
            var after = 1;
            if (v1.value.detailOrder === undefined) {
                if (v2.value.detailOrder === undefined) {
                    return v1.value.selectPosition < v2.value.selectPosition ? before : after;
                } else {
                    return after;
                }
            } else if (v2.value.detailOrder === undefined) {
                return before;
            } else {
                return v1.value.detailOrder < v2.value.detailOrder ? before : after;
            }
        }

        function updateFlyerImagesDetailOrder() {
            vm.allFlyerImages.forEach(function (flyerImage) {
                var index = vm.detailFlyerImages.findIndex(function (detailFlyerImage) {
                    return flyerImage.id === detailFlyerImage.id;
                });
                if (index >= 0) {
                    flyerImage.detailOrder = index;
                } else {
                    flyerImage.detailOrder = undefined;
                }
            });
        }

        function toggleDetailFlyerImage(flyerImage) {
            const detailFlyerImageIndex = vm.detailFlyerImages.findIndex(function (detailFlyerImage) {
                return detailFlyerImage.id === flyerImage.id;
            });
            if (detailFlyerImageIndex >= 0) {
                vm.detailFlyerImages.splice(detailFlyerImageIndex, 1);
            } else {
                vm.detailFlyerImages.push(flyerImage);
            }
            vm.updateFlyerImagesDetailOrder();
        }

        function getContextTranslateKey(baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        }

        function update() {
            $uibModalInstance.close(vm.detailFlyerImages);
        }

        function close() {
            $uibModalInstance.close();
        }
    }
})();
